import Skeleton from 'react-loading-skeleton';

import Container from '@/components/@base/container';

export default function Loading() {
  return (
    <Container
      className='my-5 overflow-hidden rounded-lg border-[1px] border-[#E9EBF1] p-[15px] last:mb-0 md:p-6'
      data-loading='question-loading'
    >
      <Container className='mb-4 flex items-center gap-2'>
        <Skeleton circle width={30} height={30} />
        <Skeleton width={90} height={25} />
      </Container>
      <Skeleton containerClassName='w-full' count={2.5} />
    </Container>
  );
}
